export class DocumentManagerPermissionModel {
    canAddDocument: boolean;
    canAddFolder: boolean;
}
